import axios from 'axios'
// import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
// import { i18nRender } from '@/locales'

// ============ Cancel previous search request (Axios 1.x + AbortController) ============
let lastSearchController = null

function attachSearchAbort (config) {
  if (lastSearchController) {
    lastSearchController.abort()
    lastSearchController = null
  }

  const controller = new AbortController()
  config.signal = controller.signal

  // bind to config to avoid old response clearing new controller
  config.__searchController = controller
  lastSearchController = controller
}

function clearSearchAbort (config) {
  if (config?.url !== '/tchelp/search/') return

  if (config.__searchController && config.__searchController === lastSearchController) {
    lastSearchController = null
  }
}
// ============================================================================

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // baseURL: '/api',
  baseURL: 'https://support.sigma-rt.com',
  withCredentials: false,
  timeout: 60000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    // 判断返回的结果是否为一个对象
    if (Object.prototype.toString.call(error.response) === '[object Object]') {
      const start = error.response.config.headers['request-startTime']
      const currentTime = new Date().getTime()
      const requestDuration = (currentTime - start)// .toFixed(2)
      error.response.requestDuration = requestDuration
    }
    // 401服务器授权失败，则需要登录重试
    if (error.response.status === 401) {
      // notification.error({
      //   message: i18nRender('title.error'),
      //   description: i18nRender('result.fail.error.authorization')
      // })
      return Promise.reject(error)
    } else {
      // notification.error({
      //   message: i18nRender('title.error'),
      //   description: error.response.statusText
      // })
      // 从 localstorage 获取 token
      // const token = storage.get(ACCESS_TOKEN)
      // if (token) {
      //   store.dispatch('Logout').then(() => {
      //     setTimeout(() => {
      //       window.location.reload()
      //     }, 1500)
      //   })
      // }
    }
  } else {
    // notification.error({
    //   message: i18nRender('title.error'),
    //   description: error.toString()
    // })
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use((config) => {
  config.headers['request-startTime'] = new Date().getTime()

  if ((config.method || 'get').toLowerCase() === 'get' && config.url === '/tchelp/search/') {
    // tcSearchMode: 'suggest' | 'submit'
    const mode = config.tcSearchMode
    if (mode !== 'submit') {
      attachSearchAbort(config)
    }
  }

  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  clearSearchAbort(response.config)
  console.log('interceptors.response :>> ', response)
  return response
}, (error) => {
  clearSearchAbort(error?.config)

  // canceled request: ignore as "normal"
  if (error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError') {
    return Promise.reject(error)
  }

  return errorHandler(error)
})

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
